import { GasType } from '../GasType'
import { GhgEmissionCalculationMaterial, GhgEmissionTonkiloCalcuationMaterial } from '../GhgEmissionCalculationMaterial'
import { TonkiloTransportType } from '../TransportType'

// Referring to government organization (経済産業省、国土交通省) in japan
// https://www.mlit.go.jp/common/001037031.pdf
// weight (ton) x distance (kilo meter) x gas emission coefficient (gram / ton x kilometer)
//  x  1 / 1,000,000 (gram / ton)
// => gas emissions weight (ton)
// 輸送重量(t) x 輸送距離(km) x 排出原単位(g / (t x km)) x 1 / 1,000,000 (gram / ton) => ガス排出重量(t)
export const calcTonkiloEmission = (ton: number, kilometer: number, coefficient: number) =>
  (ton * kilometer * coefficient) / 1_000_000

// https://www.mlit.go.jp/common/001037031.pdf Page.8
const tonkiloCo2CoeffMap: Map<TonkiloTransportType, number> = new Map([
  // Tonkilo method no more supports truck transport type. But remains them for backward compatibles.
  // Delete below when migrate ghg emission
  ['light-cargo', 232],
  ['gasoline-light-cargo', 232],
  ['gasoline-lt-2t', 279],
  ['gasoline-gte-2t', 371],
  ['light-oil-lt-2t', 315],
  ['light-oil-gte-2t-lt-5t', 367],
  ['light-oil-gte-5t-lt-9t', 472],
  ['light-oil-gte-9t-lt-12t', 498],
  ['light-oil-gte-12t-lt-17t', 525],
  ['light-oil-gte-17t', 656],
  // Delete above when migrate ghg emission

  ['railway', 22],
  ['aviation-international', 903],
  ['aviation-domestic', 1443],
  ['container-ship-domestic', 39],
  ['container-ship-asia-route', 26],
  ['container-ship-european-route', 14.2],
  ['container-ship-north-american-route', 15.7],
])

function convertToCalcMaterial(material: unknown) {
  const {
    transportType,
    calculationType,
    gasTypes,
    weight,
    distance,
  } = material as GhgEmissionTonkiloCalcuationMaterial
  return {
    calculationType,
    transportType,
    gasTypes,
    weight,
    distance,
  } as GhgEmissionTonkiloCalcuationMaterial
}

export function calcTonkloCo2Emission(calcMaterial: GhgEmissionCalculationMaterial) {
  const tonkiloMaterial = convertToCalcMaterial(calcMaterial)
  const transportType = tonkiloMaterial.transportType as TonkiloTransportType
  const co2Coeff = tonkiloCo2CoeffMap.get(transportType) ?? 0
  return calcTonkiloEmission(tonkiloMaterial.weight, tonkiloMaterial.distance, co2Coeff)
}

export function getTonkiloGasEmissionMap(material: GhgEmissionCalculationMaterial) {
  const coefficientMap = new Map<GasType, number>()
  material.gasTypes.forEach((gasType) => {
    switch (gasType) {
      case 'CO_2':
        coefficientMap.set(gasType, calcTonkloCo2Emission(material))
        break
      case 'CH_4':
      case 'N_2O':
      default:
        coefficientMap.set(gasType, 0) // not supported yet
    }
  })

  return coefficientMap
}
